import { IListType } from 'APIPackage/CatalogsModule/interfaces/IListType';

import { IListTypeSelectOption } from '../interfaces/IListTypeSelectOption';

export const createListTypeSelectOption = (listType: IListType): IListTypeSelectOption => ({
  ...listType,
  id: listType.type,
  label: listType.description,
  value: listType.type,
});
